import dayjs from 'dayjs'
import Calendar from 'react-calendar'
import { useState } from 'react'
import { useInterventiCalendario } from '../hooks/interventi'

export default function CalendarField({
  dataIntervento,
  setDataIntervento,
  type,
}: {
  dataIntervento: string
  setDataIntervento: (data: string) => void
  type: string
}) {
  const [datesCalendario, setDatesCalendario] = useState<string[]>([])

  const { data: interventiMonth } = useInterventiCalendario({
    data_intervento__gte:
      datesCalendario[0] ?? dayjs().startOf('month').format('YYYY-MM-DD'),
    data_intervento__lte:
      datesCalendario[1] ?? dayjs().endOf('month').format('YYYY-MM-DD'),
    stato: 'programmato',
  })

  return (
    <>
      <div className="form-group">
        <label className="label-m text-body-secondary">Calendario</label>
        <Calendar
          formatShortWeekday={(locale, date) => {
            return date
              .toLocaleDateString(locale, { weekday: 'short' })
              .slice(0, 2)
          }}
          onActiveStartDateChange={({ activeStartDate }) => {
            setDatesCalendario([
              dayjs(activeStartDate).startOf('month').format('YYYY-MM-DD'),
              dayjs(activeStartDate).endOf('month').format('YYYY-MM-DD'),
            ])
          }}
          // show only 2 letters of the week day
          locale="it-IT"
          tileClassName={({ date }) => {
            const dateFormatted = dayjs(date).format('YYYY-MM-DD')
            const interventiCount = interventiMonth?.filter(
              (intervento) => intervento.data_intervento === dateFormatted
            ).length
            // whehave colors from color-scale-0 to color-scale-10 in the css
            // scale interventiCount in scale colors
            const min = 0
            const max = 10

            const scale = Math.floor(
              ((interventiCount ?? 0 - min) * 10) / (max - min)
            )

            const scaleClamped = Math.min(10, Math.max(0, scale))

            return type === 'verifica_periodica'
              ? `color-scale-${scaleClamped}`
              : `color-scale-taratura-${scaleClamped}`
          }}
          onChange={(date: any) => {
            const dateFormatted = dayjs(date).format('YYYY-MM-DD')
            setDataIntervento(dateFormatted)
          }}
          value={dataIntervento ? new Date(dataIntervento) : new Date()}
          // change position of arrows and month
        />
      </div>
      <div className="my-3 position-relative">
        <div
          style={{
            height: 16,
            width: '100%',
            background:
              type === 'verifica_periodica'
                ? 'linear-gradient(90deg, #FFF 0%, #107B6E 100%)'
                : 'linear-gradient(90deg, #FFF 0%, #6610F2 100%)',
          }}
        ></div>
        <div className="d-flex justify-content-between position-absolute w-100">
          <div className="text-center text-body-secondary">Vuoto</div>
          <div className="text-center text-body-secondary">Pieno</div>
        </div>
      </div>
      <div className="form-group mt-4">
        <label className="label-m text-body-secondary">
          Giorno selezionato
        </label>
        <div className="heading-h5">
          {dataIntervento ? dayjs(dataIntervento).format('DD MMMM YYYY') : ''}
        </div>
      </div>
    </>
  )
}
